























import { Vue, Component, Prop, Model } from 'vue-property-decorator';

import SelectCustom from '@/components/select/SelectCustom.vue';

import { SelectItem, SelectValue } from './types';

@Component({
    name: 'BaseSelect',
    components: {
        SelectCustom,
    }
})
export default class BaseSelect extends Vue {
    @Model('update:modelValue', { type: Object, default: null }) modelValue!: SelectValue;
    @Prop({ type: String, default: '' })  title!: string;
    @Prop({ type: Array, required: true }) items!: SelectItem;
    @Prop({ type: String, default: '' }) error!: string;
    @Prop({ default: false, type: Boolean }) disabled!: boolean;
    @Prop({ default: false, type: Boolean }) readonly!: boolean;
    @Prop({ default: false, type: Boolean }) noTitleGap!: boolean;

    get modelWrapper() {
        return this.modelValue;
    }

    set modelWrapper(value: SelectValue) {
        this.$emit('update:modelValue', value)
    }

    get hasTitle() {
        return Boolean(this.title || this.$scopedSlots.title);
    }
}
